<template>
  <div class="back-color">
    <div class="appIntroIco"></div>
    <!-- <loading /> -->
  </div>
</template>

<script>
import service from '@/backend/modnpay_app_api'
/* eslint-disable eqeqeq */
export default {
  data () {
    return {
      orderAppUser: ''// 1 회원
    }
  },
  created () {
    // 네이티브 앱 -> 웹뷰(프론트) 호출
    this.nativeToWebViewCallbackFunc()
    console.log('## AppIntroPage')
    // bridge -> callback -> deviceInfo() -> appResult update -> watch appGetAppEncPasswd -> watch encPasswd
    this.appGetAppDeviceInfo() // 앱 접속 초기 세팅
  },
  watch: {
    appResult () {
      this.appGetAppEncPasswd()
    },
    encPasswd () {
      const auth = localStorage.getItem('Authorization')
      // 비회원인데 비밀번호 바뀌면 회원가입으로
      if (!auth) {
        console.log('## not registered User')
        this.$router.replace({ name: 'AppOrderSelect' })
      } else if (this.appResult.autoLoginFlag == 1 && this.encPasswd !== '') {
        // 회원이면서 비밀번호 공백 아니고 자동 로그인 플래그  1이면 자동 로그인
        console.log('## auto login')
        this.appAutoLogin()
      } else {
        if (this.encPasswd == '') {
          this.$router.replace({ name: 'AppOrderSelect' })
        } else if (this.appResult.autoLoginFlag == 1) {
          console.log('## watch encPasswd')
          console.log(this.appResult)
          this.appAutoLogin()
        } else {
          this.$router.replace({ name: 'AppLogin' })
        }
      }
    }
  },
  methods: {
    // 앱 로그인
    async appAutoLogin () {
      const req = {
        deviceId: localStorage.getItem('deviceId'),
        encPasswd: this.encPasswd
      }
      const { data } = await service.appAutoLogin(req)
      const code = data.resultCode

      if (code == 0) {
        localStorage.setItem('Authorization', data.accessToken)
      }
      this.nextPage()
    },
    nextPage () {
      if (this.$route.query.orderCode) { // 앱 푸쉬
        this.$router.replace({ name: this.$route.query.page, query: { orderCode: this.$route.query.orderCode } })
      } else if (this.$route.query.page) { // 빠른 상품
        console.log('빠른상품')
        this.$router.replace({ name: this.$route.query.page })
      } else {
        console.log('## AppIntroPage-nextPage-appMoveMain')
        this.appMoveMain()
      }
    }
  }
}
</script>

<style scoped>
.back-color {
  width: 100%;
  height: 100%;
  background-color: #FF5522;
}
.appIntroIco{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  background: url('../assets/img/img_intro_01.png') no-repeat center;
  background-size: contain;
  width: 110px;
  height: 110px;
}
</style>
